module.exports = __webpack_public_path__ + "static/img/header.af914795.png";